import React, { useState, } from 'react'
import { Header2, LinkButton, Text } from '../styles/Components'
import { FAQWrapper } from './styles'

const FAQ = ({ data, url }) => {
  const [openQuestion, setOpenQuestion] = useState(null)

  // ***Leaving this in case Gorgias creates an endpoint we can use

  // const [FAQ, setFAQ] = useState([])
  // const [showAll, setShowAll] = useState(false)

  // useEffect(() => {
  //   axios.get(URL + zendeskArticle)
  //     .then(({ data: { articles } }) => {
  //       (
  //         setFAQ(articles)
  //       )
  //     })
  // }, [zendeskArticle])

  const handleClick = (evt) => {
    const { id } = evt.target
    setOpenQuestion((openQuestion === id) ? null : id)
  }

  return (
    <FAQWrapper>
      <Header2>FAQs</Header2>
      <div className='faq-container'>
        {
          data.map((q) => {
            // if (!showAll && i > 2) { return null }
            return (
              <div
                key={q.id}
                className='faq-item'
              >
                <div className='faq-title-container'>
                  {/* <div className='faq-carrot' /> */}
                  <span className='faq-title' onClick={handleClick}>
                    <Text id={q.id} variant='medium'>
                      {q.title}
                    </Text>
                  </span>
                </div>

                <div
                  dangerouslySetInnerHTML={{ __html: q.body }}
                  className={(Number(openQuestion) === q.id) ? 'faq-body faq-open' : 'faq-body'}
                />
              </div>
            )
          })
        }
      </div>

      <LinkButton
        color={'#000'}
        outline
        href={url}
        target='_blank'
      >
        See All FAQs
      </LinkButton>
    </FAQWrapper>
  )
}

export default FAQ
